import { SET_CUSTOM_DUTY_INVOICES } from 'store/types/customDutyInvoice';

const initialState = {
  customDutyInvoices: [],
};

const customDutyInvoice = (state = initialState, action) => {
  switch (action.type) {
    case SET_CUSTOM_DUTY_INVOICES:
      return {
        ...state,
        customDutyInvoices: action.payload,
      };

    default:
      return state;
  }
};

export default customDutyInvoice;
